import { createSlice } from '@reduxjs/toolkit';

const initialNotificationMessage = {
  show: false,
  message: '',
  severity: 'success',
};

const resetNotificationMessage = (state) => {
  state.notificationMessage = { ...initialNotificationMessage };
  return state;
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    notificationMessage: { ...initialNotificationMessage },
  },
  reducers: {
    hideNotificationMessage(state) {
      state.notificationMessage.show = false;
      return state;
    },
    showSuccessMessage(state, action) {
      state.notificationMessage = {
        message: action.payload,
        show: true,
        severity: 'success',
        duration: 3000,
      };
      return state;
    },
    showErrorMessage(state, action) {
      // Accepts either a plain string or { message, duration }.
      const { message, duration } =
        typeof action.payload === 'string'
          ? { message: action.payload }
          : action.payload;

      state.notificationMessage = {
        message,
        show: true,
        severity: 'error',
        duration: duration || 3000,
      };
      return state;
    },
  },

  extraReducers: {
    'auth/logout': resetNotificationMessage,
    'auth/logoutUser/fulfilled': resetNotificationMessage,
    'auth/logoutUser/rejected': resetNotificationMessage,
  },
});

export const { showSuccessMessage, showErrorMessage, hideNotificationMessage } =
  dashboardSlice.actions;

export default dashboardSlice.reducer;
